/**
 * localStorage sarmalayıcısı. Gizli sekme / iOS depolama tahliyesi / engelli site verisinde erişim atabilir —
 * her okuma-yazma try/catch; uygulama depolama olmadan da çalışır (yalnız oturum hatırlanmaz).
 *
 * Anahtarlar işletme (slug) bazındadır: aynı cihazda iki işletmenin uygulaması ayrı oturum tutar.
 */
const PREFIX = 'superapp';

function key(scope: string | null, name: string): string {
  return scope ? `${PREFIX}:${scope}:${name}` : `${PREFIX}:${name}`;
}

export function readJson<T>(scope: string | null, name: string): T | null {
  try {
    const raw = window.localStorage.getItem(key(scope, name));
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function writeJson(scope: string | null, name: string, value: unknown): void {
  try {
    if (value === null || value === undefined) window.localStorage.removeItem(key(scope, name));
    else window.localStorage.setItem(key(scope, name), JSON.stringify(value));
  } catch {
    // depolama yok/dolu — sessiz geç
  }
}

export function removeKey(scope: string | null, name: string): void {
  try {
    window.localStorage.removeItem(key(scope, name));
  } catch {
    // yok say
  }
}

/** Çevrimdışı kopya zarfı: veri + kayıt zamanı. */
export interface CacheEnvelope<T> {
  savedAt: number;
  data: T;
}

export function cacheWrite<T>(scope: string, name: string, data: T): void {
  writeJson(scope, `cache:${name}`, { savedAt: Date.now(), data } satisfies CacheEnvelope<T>);
}

export function cacheRead<T>(scope: string, name: string, maxAgeMs?: number): CacheEnvelope<T> | null {
  const env = readJson<CacheEnvelope<T>>(scope, `cache:${name}`);
  if (!env) return null;
  if (maxAgeMs !== undefined && Date.now() - env.savedAt > maxAgeMs) return null;
  return env;
}
